import { REQUESTDOMAIN, ENV, pbENV, isTxEnv, project, curScheme, curQQ, isLocal, curPCWeb } from 'CONFIG/config';
import { ORIGIN, PRE, SELFRESOURCE, SELFPAGE, RESOURCEPATH, RESOURCEJSON, RESOURCEIMG } from 'CONFIG/config';
import { envData, envConf } from 'ENV';
import validate from 'UTILS/validate';
import { typeIs } from 'UTILS/utils';
import { browser } from 'UTILS/browser';
import { checkWebp } from 'UTILS/lite/utils.lite';
import { toProcessRout } from 'UTILS/nativeBridge';
import axios from 'axios';

// 通用变量定义
let INAPP = false;
let INPC = false;
let inTransit = () => {};
if (browser.isOxygen || browser.isCaramel || browser.isCallme || browser.isOxPC) {
  const commonOx = require('./oxygen');
  INAPP = commonOx.INAPP;
  INPC = commonOx.INPC;
  inTransit = commonOx.inTransit;
} else if (browser.isHydrogen || browser.isYoyo || browser.isHydrogenPC) {
  const commonHydrogen = require('./hydrogen');
  INAPP = commonHydrogen.INAPP;
  INPC = commonHydrogen.INPC;
  inTransit = commonHydrogen.inTransit;
} else {
  console.log('没有找到当前的项目配置变量');
}
const INCLIENT = INAPP || INPC;
const PC_WEB_LINK = curPCWeb || '';
const IS_IOS = browser.isIOS;
const IS_ANDROID = browser.isAndroid;

// APP打开个人名片
function openPersonalCard(pid) {
  if (!pid) return;
  if (INPC) return window.pcBridgeClient.showVisitingCard(pid);
  window.jsBridgeClient.getPlayerData(pid);
}

/**
 * @param {*} icon 兼容头像和资源新旧地址,待测试
 * @param {number} [width=50] 返回图片宽度,默认50,等比缩放
 * @param {string} [domain=REQUESTDOMAIN] 替换域名
 * @param {Boolean} [isOptimize=true] 是否处理优化
 * @param {Boolean} [isCircle=false] 是否返回圆形图
 * @returns
 */
function picAnalysis(icon, width = 120, domain, isOptimize, isCircle = false) {
  // 默认参数
  domain = domain || REQUESTDOMAIN;
  isOptimize = isOptimize || true;

  if (!icon || validate(['isAbsoluteUrl', 'dataUrl'], icon)) return icon;

  const isDefPic = /^[a-z0-9]*$/gi.test(icon);

  // oss优化
  let suffix = '';
  if (isOptimize && (validate('img', icon) || isDefPic)) {
    suffix += `?x-oss-process=image`;
    if (width) suffix += `/resize,m_lfit,w_${width}`;
    if (isCircle) suffix += `/circle,r_${width / 2}`;
    if (checkWebp()) {
      suffix += '/format,webp';
    } else if (isCircle && !/\.png$/.test(icon)) {
      // 不支持webp转圆形会有白色,需要转png
      suffix += '/format,png';
    }
  }

  // 替换默认头像
  if (isDefPic) {
    return (icon = `${RESOURCEIMG}/avator_filleted.png${suffix}`);
  }

  // 判断新旧解析的标准
  const lineStr = icon.charAt(0) === '/' ? '' : '/';
  const apiPic = `${domain}${lineStr}${icon}`;
  const ossPic = `${ORIGIN}${lineStr}${icon}${suffix}`;

  // 正式服不需要往下区分了，还是要区分
  // if (ENV === 'prod') return ossPic;

  if (/^\/?upload\//g.test(icon)) {
    if (/(beta|alpha|prod|pre|aut)/g.test(icon)) return ossPic;
    return apiPic;
  } else if (/^\/?(beta|alpha|prod|pre|aut)\/resources\//g.test(icon)) {
    if (pbENV !== 'prod' && !/(beta|alpha|pre|aut)\//g.test(icon)) return apiPic;
    return ossPic;
  } else {
    // 解析图片路径,Icon为需要解析的Icon，idx为0和1，代表不同尺寸的图片，一般头像都用0
    return `${domain}/upload/icon/${icon.substring(0, 2)}/${icon.substring(0, 4)}/${icon}_0.jpg`;
  }
}

let enter = null;

function getRemoteEnter() {
  const remote = `${RESOURCEJSON}/enter.json?${+new Date()}`;
  return axios.get(remote).then((res) => res.data);
}

/**
 * 获取vuecommonality的项目配置
 * @param {String} target 项目key，例如官网：official，周星：weekStar，分享：invite
 * target为 customerService时必须要传search参数，search参数有三个：source(来源：默认为app)、noTurn(是否跳转到PC端：0|1)、mark(活动标记：自定义值，可传活动目录名，例如塔罗牌: source=app&noTurn=1&mark=StarSignComplaint)
 */
let getEnterConf = async (target, search) => {
  // 请求入口配置
  const data = await getRemoteEnter();
  if (!data) return {};

  // 处理参数
  const DEBUG = pbENV === 'prod' ? '' : '?debug=1';

  // 拼装数据
  const newData = (key, params) => {
    let res = data[key];
    if (res) {
      res = {
        ...res,
        wholeUrl: `${PRE}${res.url}${params}${res.path || ''}`,
      };
    }
    return res;
  };
  enter = newData;

  // 返回逻辑
  getEnterConf = (target, search) => {
    const params = search ? `${DEBUG ? DEBUG + '&' : '?'}${search}` : DEBUG;
    // 返回结果
    let finallyVal = null;
    if (typeIs('Array', target)) {
      finallyVal = target.map((key) => newData(key, params));
    } else if (typeIs('String', target)) {
      finallyVal = newData(target, params);
    } else {
      finallyVal = {};
      Object.keys(data).forEach((key) => {
        finallyVal[key] = newData(key, params);
      });
    }
    return finallyVal;
  };

  return getEnterConf(target, search);
};

/**
 * 跳转页面
 * @param {} type 入口配置对应的key || 完整地址
 */
async function jumpUrl(type, search) {
  let url = '';
  const isUrl = validate('URL', type);
  if (isUrl) {
    if (search) {
      const sign = type.indexOf('?') !== -1 ? '&' : '?';
      url = type + sign + search;
    } else {
      url = type;
    }
  } else {
    // 充值是单独路由
    if (type === 'officialAccounts' && INAPP && browser.isIOS) return jsBridgeClient.showRecharge();
    url = await getEnterConf(type, search);
    url = url.wholeUrl;
  }

  if (INPC && /^((mizhua|oxygen|hydrogen|yoyo|caramel)?:\/\/)[^\s]+/.test(url)) return toProcessRout(url);
  !isLocal && INAPP ? (browser.isIOS ? jsBridgeClient.openPage('', url) : jsBridgeClient.jumpInternalRoute(url)) : (location.href = url);
}

// 获取下载包的路径
// 传key可返回指定key的value
let getDownloadPath = async (key) => {
  const res = await axios.get(`https://pub.res.devop.xinyu100.com/package/${project}/download.json?${+new Date()}`);
  const data = res.data;
  getDownloadPath = (key) => {
    if (key && Object.keys(data).indexOf(key) !== -1) {
      return data[key];
    }
    return data;
  };
  return getDownloadPath(key);
};

//唤醒QQ
function handleWakeQQ(qqNumber = '2853992296') {
  //兼容ios浏览器打开
  if (browser.isIOS) {
    console.log('要唤起的scheme', `mqqwpa://im/chat?chat_type=wpa&uin=${qqNumber}&version=1&src_type=web&web_src=oicqzone.com`);
    location.href = `mqqwpa://im/chat?chat_type=wpa&uin=${qqNumber}&version=1&src_type=web&web_src=oicqzone.com`;
    return;
  }
  location.href = `http://wpa.qq.com/msgrd?v=3&uin=${qqNumber}&site=qq&menu=yes`;
}

// 调起客户端的普通客服
function handleWakeService(data) {
  const { mark, isQQ, isQidian } = data || {};

  if (isQQ && curQQ) {
    // 跳转qq客服
    handleWakeQQ(curQQ);
  } else if (isQidian) {
    // 跳转企点客服
    const url = 'https://static.qidian.qq.com/2/chat/h5/index.html?linkType=1&env=ol&kfuin=2885717673&fid=159&key=f5509f24881025d900e87da7be6dc753&cate=7&type=10&ftype=1&_type=wpa&qidian=true';
    jumpUrl(url);
  } else if (!INCLIENT) {
    // 站外带scheme跳转
    let toUrl = `${PRE}/commonality/customerService/index.html?source=app&noTurn=1`;
    if (ENV !== 'prod') {
      toUrl += '&debug=1';
    }
    jumpUrl(`${curScheme}?dyaction=web&url=${encodeURIComponent(toUrl)}`);
  } else {
    // 跳转app客服
    jumpUrl('customerService', `source=app&noTurn=1` + (mark ? `&mark=${mark}` : ''));
  }
}

// 性能统计
const getWebInfo = () => {
  return new Promise((resolve, reject) => {
    if (isLocal) return reject('本地环境不上传');

    require('UTILS/stats/webStats');
    window.WEBSTATS.getWebInfo((_data) => {
      const { loadPage, domReady, total, domActive, TTFB, firstPaintData, navigationStart } = _data;
      const client = browser.isIOS ? 'ios' : browser.isAndroid ? 'android' : 'pc';
      const dataJSON = {
        client,
        title: document.title,
        page_name: location.href,
        total_load_time: loadPage, // 页面加载时长, PLT
        total_dom_ready_time: domReady, // DOM Ready 时长
        total_dom_completed_time: total, // DOM Complete 时长, 总时长
        total_dom_interactive_time: domActive, // DOM Interactive 时长
        total_ttfb_time: TTFB, // 首字节等待时间 TTFB
        first_paint: firstPaintData.firstPaint, // 首次内容渲染时长 FCP
        first_contentful_paint: firstPaintData.firstContentfulPaint, // 首次有效渲染时长 FMP
        largest_contentful_paint: window.lcpTime - navigationStart || 0, // 可视区域中最大的内容元素呈现到屏幕上的时间 LCP
      };
      resolve(dataJSON);
    });
  });
};

/**
 * 判断当前设置是否支持constant(safe-area-inset-top)或env(safe-area-inset-top)；
 * 部分Android设备，可以认识safa-area-inset-top，但会将其识别为0
 * @returns {boolean} 当前设备是否支持安全距离
 */
const isSupportSafeArea = () => {
  let status = 0;
  const div = document.createElement('div');
  const id = 'test-check-safe-area';
  const styles = ['position: fixed', 'z-index: -1', 'height: constant(safe-area-inset-top)', 'height: env(safe-area-inset-top)'];
  div.style.cssText = styles.join(';');
  div.id = id;
  document.body.appendChild(div);
  const areaDiv = document.getElementById(id);
  if (areaDiv) {
    status = areaDiv.offsetHeight > 0 ? 1 : -1; // 该 div 的高度是否为 0
    areaDiv.parentNode.removeChild(areaDiv);
  }
  return status === 1;
};

export {
  INAPP,
  INPC,
  isLocal,
  inTransit,
  INCLIENT,
  PC_WEB_LINK,
  IS_IOS,
  IS_ANDROID,
  picAnalysis,
  getDownloadPath,
  handleWakeQQ,
  handleWakeService,
  getEnterConf,
  getWebInfo,
  isSupportSafeArea,
  jumpUrl,
  openPersonalCard,
  ORIGIN,
  PRE,
  SELFRESOURCE,
  SELFPAGE,
  RESOURCEPATH,
  RESOURCEJSON,
  RESOURCEIMG,
};
